import { FONTSIZE, defaultFontSize } from '../../configs/LayoutConfig';
import { getQueryParams } from './Common';

const KEY_FONT_SIZE = 'fontSize';

export const changeUIFontSize = fontSize => {
  Object.keys(FONTSIZE).forEach(key => {
    document.body.classList.remove(FONTSIZE[key]);
  });
  document.body.classList.add(fontSize);
};

export const getFontSize = () => {
  return (
    getQueryParams('fontSize') ||
    localStorage.getItem(KEY_FONT_SIZE) ||
    defaultFontSize
  );
};

export const saveFontSize = fontSize => {
  localStorage.setItem(KEY_FONT_SIZE, fontSize);
};
